module.exports = __webpack_public_path__ + "4ebf2ff7508d98dd39230152525ef24a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/MainMenu/MenuDrinks.png
// module id = 410
// module chunks = 0